"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changePasswordAction } from "@/resources/actions/auth.actions";
import { queryKeys } from "@/lib/query-keys";

export interface ChangePasswordData {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

/**
 * Change password mutation hook
 * Handles password change with error handling
 */
export function useChangePassword() {
  const queryClient = useQueryClient(); // Add this line

  return useMutation({
    mutationFn: async (data: ChangePasswordData) => {
      const result = await changePasswordAction({
        current_password: data.current_password,
        new_password: data.new_password,
        confirm_password: data.confirm_password,
      });

      if (result.error) {
        throw new Error(result.error);
      }

      return result.data;
    },
    onError: (error: Error) => {
      console.error("Password change failed:", error.message);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.userProfile() });
    },
  });
}
